import { gettext } from '@eventbrite/i18n';
import React, { Component } from 'react';
import { InfoTLDType } from '../../../types';
import './ContactInfo.scss';

class ContactInfo extends Component<InfoTLDType> {
    render() {
        const { infoTLD }: InfoTLDType = this.props;
        const showContactInfo =
            infoTLD.contact_sales_phone_number || infoTLD.sales_email;
        let sales_email,
            contact_info = null;

        if (infoTLD.sales_email) {
            sales_email = (
                <div className="eds-g-cell eds-g-cell-12-12 eds-g-cell-md-6-12 eds-g-cell--no-gutters">
                    <p>
                        <a href={`mailto: ${infoTLD.sales_email}`}>
                            {infoTLD.sales_email}
                        </a>
                    </p>
                </div>
            );
        }
        if (showContactInfo) {
            contact_info = (
                <div className="eds-g-group">
                    <div className="eds-g-cell eds-g-cell-10-12 eds-g-cell-lg-12-12 eds-g-offset-1-12 eds-g-offset-lg-0-12">
                        <h3 className="eds-text-hm eds-text-weight--light">
                            {gettext('Organizing a large event?')}
                        </h3>
                    </div>
                    <div className="eds-g-cell g-cell-10-12 eds-g-cell-lg-12-12 eds-g-offset-1-12 eds-g-offset-lg-0-12 eds-l-mar-top-3">
                        <h3 className="eds-text-hs">
                            {gettext('Talk to an event expert')}
                        </h3>
                        <div className="g-group">{sales_email}</div>
                    </div>
                </div>
            );
        }

        return (
            <section className="eds-landing-section eds-landing-section--white section-contact-info">
                <div className="eds-g-grid">
                    {contact_info}
                    <div className="eds-g-group eds-l-mar-top-5 eds-l-pad-vert-5 eds-l-sm-pad-vert-3">
                        <div className="eds-g-cell eds-g-cell-10-12 eds-g-cell-lg-12-12 eds-g-offset-1-12 eds-g-offset-lg-0-12">
                            <h3 className="eds-text-hm eds-text-weight--light">
                                {gettext(
                                    'Going to an event or need product help?',
                                )}
                            </h3>
                        </div>
                        <div className="eds-g-cell eds-g-cell-10-12 eds-g-cell-lg-12-12 eds-g-offset-1-12 eds-g-offset-lg-0-12 eds-l-mar-top-3">
                            <div className="eds-g-group">
                                <div className="eds-g-cell eds-g-cell-12-12 eds-g-cell-md-6-12 eds-g-cell--no-gutters">
                                    <h3 className="eds-text-hs">
                                        {gettext('Eventbrite Help Center')}
                                    </h3>
                                    <p>
                                        <a href="/support">
                                            {gettext(
                                                'Check out our videos and tutorials',
                                            )}
                                        </a>
                                    </p>
                                </div>
                                <div className="eds-g-cell eds-g-cell-12-12 eds-g-cell-md-6-12 eds-g-cell--no-gutters">
                                    <h3 className="eds-text-hs">
                                        {gettext('Customer Experience Team')}
                                    </h3>
                                    <p>
                                        <a href={infoTLD.contact_us_url}>
                                            {gettext('Contact support')}
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="eds-g-group eds-l-mar-top-5">
                        <div className="eds-g-cell eds-g-cell-10-12 eds-g-cell-lg-12-12 eds-g-offset-1-12 eds-g-offset-lg-0-12">
                            <h3 className="eds-text-hm eds-text-weight--light">
                                {gettext('Press Inquires')}
                            </h3>
                            <p>
                                <a href={`mailto:${infoTLD.press_email} `}>
                                    {infoTLD.press_email}
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default ContactInfo;
